<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded">
</app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add Asset Validation</div>

  </div>
  <div class="modal-body asset-valiation-modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="masterNameSelected" (change)="onMasterChange($event.target.selectedIndex)">
        <option *ngFor="let master of masterNameObj" [value]="master.id">{{master.masterName}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="columnNameSelected">
        <option *ngFor="let column of columnNameObj" [value]="column.columnId">{{column.columnName}}</option>
      </select>
    </div>
    <div class="form-group">
      <textarea type="text" class="form-control radius-0 font-13" [(ngModel)]="validationValues"
             placeholder="Enter validation values"></textarea>
             <span class="textareamsg">* For mutiple please enter comma separated values </span>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>
